import { ABaseModel } from '../abstracts/ABaseModel.js';
import { IVisitor, IVisitorSetting } from '../interfaces/Visitor.js';

/**
 * Visitor
 */
class Visitor extends ABaseModel implements IVisitor {
  id: number;
  created: string;
  autoLogin: boolean;
  cohort: string;
  language: string;
  locale: string;
  role: string;
  email: string;
  ipAddress: string;
  userAgent: string;
  unitSystem: string;
  unitLength: string;
  unitWeight: string;
  isUser: boolean;
  isCustomer: boolean;
  storeCode: string;
  countryCode: string;
  shippingCountryCode: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * VisitorSetting
 */
class VisitorSetting extends ABaseModel implements IVisitorSetting {
  id: number;
  visitorId: number;
  type: number;
  name: string;
  value: any;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { Visitor, VisitorSetting };
